export default {
  NULL: null,
  MAIN: 'MAIN',
  EXTENDED: 'EXTENDED',
};
